import { makeUIText } from './internal/makeUIText';

/**
 * Компонет типогрфики для оформления простого текста в UI
 */
export var UIText1 = makeUIText({
  fontSize: '16px',
  lineHeight: '6u',
  letterSpacing: '0'
});

/**
 * Компонет типогрфики для оформления простого текста в UI
 */
export var UIText2 = makeUIText({
  fontSize: '14px',
  lineHeight: '5u',
  letterSpacing: '0'
});

/**
 * Компонет типогрфики для оформления простого текста в UI
 */
export var UIText3 = makeUIText({
  fontSize: '12px',
  lineHeight: '4u',
  letterSpacing: '0'
});